import { render, staticRenderFns } from "./WhatsAppComponent.vue?vue&type=template&id=a972c3fe&scoped=true"
import script from "./WhatsAppComponent.vue?vue&type=script&lang=js"
export * from "./WhatsAppComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a972c3fe",
  null
  
)

export default component.exports